'use client';

import { HamburgerMenuIcon } from '@radix-ui/react-icons';
import Link from 'next/link';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/components/ui/collapsible';
import LogoWhiteIcon from '@/icons/LogoWhiteIcon';
import type { Bookmark } from '@/types/bookmarks';
import type { User } from '@/types/user';
import AccountPopover from './Account/Popover';
import Navlinks from './Navlinks';

const MobileNav = ({ bookmarks, user }: { bookmarks: Bookmark[]; user: User }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Collapsible
      open={isOpen}
      onOpenChange={setIsOpen}
      className='bg-bui-color-black'
    >
      <div className='flex items-center justify-between gap-4'>
        <Link
          href='/'
          className='inline-block'
          aria-label='Booli, till startsidan.'
        >
          <LogoWhiteIcon className='h-7 w-auto' />
        </Link>
        <div className='flex items-center gap-4'>
          <CollapsibleTrigger asChild>
            <Button>
              <HamburgerMenuIcon className='h-4 w-4' />
              <span className='sr-only'>Expandera</span>
            </Button>
          </CollapsibleTrigger>
        </div>
      </div>
      <CollapsibleContent
        className='pointer-events-none fixed inset-0 top-[64px] z-100 bg-inherit px-8 opacity-0 shadow-lg
          transition-opacity duration-100 ease-in-out data-[state=open]:pointer-events-auto
          data-[state=open]:opacity-100'
      >
        <div className='flex flex-col items-end gap-6 font-semibold'>
          <Navlinks
            user={user}
            setIsOpen={setIsOpen}
          />
          <AccountPopover
            bookmarks={bookmarks}
            user={user}
          />
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};

export default MobileNav;
